import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";

import NotFound from "core/NotFound";
import LoadingSpinner from "core/LoadingSpinner";
import CreatorProfilePage from "frontend/components/creator-profile";
import NonCreatorPublicProfile from "./NonCreatorPublicProfile";

import { GET_USER_DATA } from "./queries";

const PublicProfilePage = () => {
    const { username } = useParams();
    const decodedUsername = decodeURIComponent(username);

    const { data: userData, loading: loadingUserData } = useQuery(
        GET_USER_DATA,
        {
            variables: { username: decodedUsername }
        }
    );

    if (loadingUserData) return <LoadingSpinner />;

    const isCreator =
        (!!userData && userData.icons && userData.icons.totalCount) ||
        (!!userData && userData.photos && userData.photos.totalCount);

    if (isCreator)
        return (
            <CreatorProfilePage
                creatorData={!!userData && userData.info}
                username={decodedUsername}
            />
        );

    const isJustAUser = !isCreator && !!userData && userData.info;
    if (isJustAUser)
        return (
            <NonCreatorPublicProfile
                userData={userData}
                username={decodedUsername}
            />
        );

    return <NotFound />;
};

export default PublicProfilePage;
